export const pricingTableId =
  process.env.NODE_ENV === 'production' ? 'prctbl_1QP5BTBdNcTVbq0F6MKKhjnw' : 'prctbl_1QKME2BdNcTVbq0FlcUvg0Hg';

export const stripePublishableKey =
  process.env.NODE_ENV === 'production'
    ? 'pk_live_51LIfGOBdNcTVbq0FBgG7bbV7kT3V2OtpUSqocsEvCzOavVKtVVrdtIVtbW6N2O2aCuiRvlwt0rlxzRoXgyd355vf00Y1FSf45U'
    : 'pk_test_51RWyQQBAIFLZyZa17VgR8d6Iw2shfPRxO4ZhNVdhZgsOk2fFLGzy9YnoaFfpSHrrkTpE7f36Fb00ZUwjCTzrQRX800Tg1FlLnn';
